import { Tab, Tabs, withStyles } from '@mui/material';
import styled from 'styled-components';
import { CustomTabsInterface } from '../../../Models/Common/CustomViewsInterfaces';

const StyledTab = styled(Tab)`
    textTransform: "none";
`

const CustomTabs = (fieldProps: CustomTabsInterface) => {
  return <Tabs value={fieldProps.selectedTab}
    onChange={(event: any, newValue: any) => fieldProps.handleOnChange(newValue)} >
    {fieldProps.items.map((item: any, index: number) => (
      <StyledTab label={item.name} value={item.id}
        id={`simple-tab-${index}`}
        key={item.name}
        aria-controls={`simple-tabpanel-${index}`}
        sx={{ textTransform: "none", fontWeight: '600', color: 'primaryText' }}
        disableRipple />
    ))};
  </Tabs>
}

export default CustomTabs;